import {
  useMutation,
  UseMutationResult,
} from '@tanstack/react-query';
import {
  EOBExtractionJobResultDTO,
  ReconcileExtractedEOBRequestDTO,
} from 'dtos';
import {
  postApiBillingReconcileExtractedEOB,
} from 'endpoints';

export default function useReconcileExtractedEOB(): UseMutationResult<
  EOBExtractionJobResultDTO,
  Error,
  ReconcileExtractedEOBRequestDTO
  > {
  return useMutation<EOBExtractionJobResultDTO, Error, ReconcileExtractedEOBRequestDTO>({
    mutationFn: (data) => postApiBillingReconcileExtractedEOB(data),
  });
}
